// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
/** Lazy loader for the SuiteNavContainer */ export const SuiteNavContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-suitenav" */ "./SuiteNavContainer")).then((bundle)=>{
        return {
            default: bundle.SuiteNavContainer
        };
    });
/** Lazy-loaded SuiteNavContainer */ export const LazySuiteNavContainer = /*#__PURE__*/ lazy(SuiteNavContainerLazyLoader);
